import { initializeApp } from 'firebase/app'
import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  type ConfirmationResult,
} from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyD1Y4qPPqM3hEqMYI1EzKNRKeqJGM6ohFU',
  authDomain: 'restarondev.firebaseapp.com',
  projectId: 'restarondev',
  storageBucket: 'restarondev.firebasestorage.app',
  messagingSenderId: '197988125114',
  appId: '1:197988125114:web:eb039666392ad34d25b583',
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)

auth.languageCode = 'uk'

let recaptchaVerifier: RecaptchaVerifier | null = null
let confirmationResultRef: ConfirmationResult | null = null

export const initRecaptcha = () => {
  if (!recaptchaVerifier) {
    recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
      size: 'invisible',
    })
  }

  return recaptchaVerifier
}

export const sendOtpToPhone = async (
  phone: string, //  +380...
): Promise<boolean> => {
  try {
    const verifier = initRecaptcha()
    confirmationResultRef = await signInWithPhoneNumber(auth, phone, verifier)
    return true
  } catch (e) {
    console.error('sendOtpToPhone error', e)
    return false
  }
}

export const confirmOtpCode = async (code: string): Promise<string | null> => {
  if (!confirmationResultRef) return null

  try {
    const userCredential = await confirmationResultRef.confirm(code)
    const token = await userCredential.user.getIdToken()
    return token
  } catch (e) {
    console.error('confirmOtpCode error', e)
    return null
  }
}
